const adminRoutes = [
  {
    path: '/',
    redirect: '/admin/login'
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('@/views/admin/AdminLogin.vue'),
    meta: { 
      title: '管理員登錄',
      requiresAuth: false
    }
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { 
          requiresAuth: true, 
          title: '管理控制台',
          tabbar: true
        }
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('@/views/admin/users/UserList.vue'),
        meta: { 
          requiresAuth: true, 
          title: '用戶管理',
          tabbar: true
        }
      },
      {
        path: 'trading',
        name: 'admin-trading',
        component: () => import('@/views/admin/trading/TradingList.vue'),
        meta: { 
          requiresAuth: true, 
          title: '交易管理',
          tabbar: true
        }
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('@/views/admin/settings/Settings.vue'),
        meta: { 
          requiresAuth: true, 
          title: '系統設置',
          tabbar: true
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/admin/login'
  }
]

export default adminRoutes
